// 用户权限
const userRight = (resolve) => {
  import('components/systemConfig/systemConfig.userRight').then((module) => {
    resolve(module)
  })
}
// 参数配置
const paramConfig = (resolve) => {
  import('components/systemConfig/systemConfig.paramConfig').then((module) => {
    resolve(module)
  })
}

// 报警管理
const alarmManagement = (resolve) => {
  import('components/systemConfig/systemConfig.alarmManagement').then((module) => {
    resolve(module)
  })
}

const systemRouter = {
  systemConfigPath: [
    {
      path: '/systemConfig/userRight', // 用户权限
      component: userRight
    },
    {
      path: '/systemConfig/paramConfig', // 参数配置
      component: paramConfig
    },
    {
      path: '/systemConfig/alarmManagement', // 报警管理
      component: alarmManagement
    }
  ]
}

export default systemRouter



// WEBPACK FOOTER //
// ./src/router/systemConfig.js